import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * The icon beside a button's label that turns into a spinner while the action
 * runs - `EX-SFX03`, ADR-0108, `docs/03` §6.
 *
 * The wrapper is always rendered, so React swaps the icon inside it and never
 * inserts a node next to the label. A browser translator replaces a label's
 * text node with its own; an icon inserted before the old one made React throw
 * `NotFoundError`, which is how pressing Save on a translated page crashed it.
 * Empty (no icon, not busy), it takes no room in the button's gap.
 */
export function BusyIcon({
  busy,
  icon,
  className,
}: {
  busy: boolean;
  /** Shown when not busy; omit for a button whose only icon is the spinner. */
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <span aria-hidden className={cn("inline-flex shrink-0 empty:hidden", className)}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : (icon ?? null)}
    </span>
  );
}
